module.exports = __webpack_public_path__ + "static/media/2021_Cadillac_XT6_int_03_6NW26_1SC_H2U.3496efa3.jpg";